import { useBoolean } from 'ahooks'
import { FC } from 'react'
import { RadioGroupItem } from '@radix-ui/react-radio-group'

import { OneOffDataAttributes } from '../../types'

import { Icon } from '../../icons'

import { CommonFieldStateProps } from '../fields/common/types'
import { propsWithClassNames, trueOrUndefined } from '../../functions'

import {
  root,
  label as labelStyle,
  indicatorControl,
  container,
  info,
  infoIcon,
  infoText
} from '../Checkbox/style.css'

import { BoxProps, ForwardedProps } from './types'

import { indicator, indicatorCheckIcon } from './style.css'

export type ItemProps = ForwardedProps & {
  boxProps?: BoxProps
}

export const Item: FC<ItemProps> = ({
  label,
  value,
  required,
  disabled,
  error,
  success,
  infoProps,
  boxProps,
  styleVariants
}) => {
  const {
    onFocus: onFocusNative,
    onBlur: onBlurNative,
    ...restBoxProps
  } = { ...boxProps }

  const [isFocus, { setFalse, setTrue }] = useBoolean()

  const icon = infoProps?.icon
  const iconProps = infoProps?.iconProps
  const text = infoProps?.text

  const hasInfo = !!infoProps
  const hasLabel = !!label

  const containerStateProps: OneOffDataAttributes = {
    'data-full-width': trueOrUndefined(styleVariants?.fullWidth),
    'data-has-info': trueOrUndefined(hasInfo)
  }

  const stateProps: CommonFieldStateProps = {
    'data-success': trueOrUndefined(success),
    'data-error': trueOrUndefined(error),
    'data-disabled': trueOrUndefined(disabled),
    'data-focus': trueOrUndefined(isFocus)
  }

  const onFocus: BoxProps['onFocus'] = (...args) => {
    setTrue()
    onFocusNative?.(...args)
  }

  const onBlur: BoxProps['onBlur'] = (...args) => {
    setFalse()
    onBlurNative?.(...args)
  }

  return (
    <div {...containerStateProps} className={container}>
      <RadioGroupItem
        {...stateProps}
        {...{ disabled, value, onFocus, onBlur }}
        {...propsWithClassNames(restBoxProps, root(styleVariants))}
      >
        <span className={indicatorControl}>
          <span className={indicator}>
            <span className={indicatorCheckIcon} />
          </span>
        </span>

        {hasLabel && (
          <span className={labelStyle}>
            {label}
            {required && <span>*</span>}
          </span>
        )}
      </RadioGroupItem>

      {hasInfo && (
        <div className={info}>
          {icon && (
            <Icon
              namespace={icon}
              {...propsWithClassNames(iconProps, infoIcon)}
            />
          )}
          {text && <p className={infoText}>{text}</p>}
        </div>
      )}
    </div>
  )
}

export default Item
